import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchSettings } from "../../store/settings/settingsSlice";

const AppProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  return <>{children}</>;
};

export default AppProvider;
